<template lang="pug">
  .container.grid-lg.py-2
    loading.v-loading(:loading='loading')
    .card(v-if='current')
      .card-body
        .form-group
          label.form-label(for='titulo') {{ 'legislacao.titulo' | tModel }}
          div {{ current.titulo }}
        .form-group
          label.form-label(for='descricao') {{ 'legislacao.descricao' | tModel }}
          div {{ current.descricao }}
        .form-group
          show-anexo(:anexo='current.anexo')
      .card-footer.text-right
        router-link.btn.btn-link.tooltip(
          :to="{name: 'app.sistema.legislacoes.edit', params: {id: current.id}}",
          :data-tooltip="$i18n.t('views.buttons.edit.label')"
          v-acl:allowed.admin.sistema.legislacoes.update
        )
          btn-content.fa-lg(name='edit')
</template>

<script>
import ShowAnexo from './anexos/ShowAnexo'

export default {
  vuex: {
    'sistema/legislacoes': {
      state: ['current'],
      actions: ['fetchOne', 'fetchUpdate'],
      getters: ['loading'],
    },
  },
  components: { ShowAnexo },
  created() {
    this.fetchOne(this.$route.params.id)
  },
}
</script>
